/**
 * ToolbarActions Component
 * 工具栏左侧弹性占位与分隔线
 */

import React from "react";
import Box from "@mui/material/Box";
import Divider from "@mui/material/Divider";
import type { Dayjs } from "dayjs";
import type { ConceptValue } from "../../../services/regulationsService";

interface ToolbarActionsProps {
  selectedMarkets: ConceptValue[];
  selectedProductTypes?: ConceptValue[];
  selectedHA?: ConceptValue[];
  selectedTags?: ConceptValue[];
  selectedTitle: string;
  fromDate: Dayjs | null;
  toDate: Dayjs | null;
  onMarketsChange: (markets: ConceptValue[]) => void;
  onProductTypesChange?: (items: ConceptValue[]) => void;
  onHAChange?: (items: ConceptValue[]) => void;
  onTagsChange?: (items: ConceptValue[]) => void;
  onTitleChange: (title: string) => void;
  onDateRangeChange: (from: Dayjs | null, to: Dayjs | null) => void;
}

/** Spacer + divider; column/list clear lives on the main toolbar (Filter icon row). */
export const ToolbarActions: React.FC<ToolbarActionsProps> = (_props) => {
  return (
    <>
      <Box sx={{ flex: 1 }} />

      <Divider orientation="vertical" variant="middle" flexItem sx={{ mx: 1 }} />
    </>
  );
};
